.container {
  display: flex;
  gap: 20px;
  align-items: center;
}

.staticMenus {
  display: flex;
  gap: 20px;
  align-items: center;
}

.link {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px 8px;
  font-size: var(--font-size-xs);
  font-weight: bold;
  color: var(--color-gray-200);

  @media screen and (width >= 641px) {
    position: relative;
    padding: unset;
    font-size: var(--font-size-sm);
    font-weight: unset;
    color: var(--color-white);

    &::before,
    &::after {
      position: absolute;
      bottom: 0;
      width: 0;
      content: '';
      border-bottom: 1px solid var(--color-white);
      transition: width 0.5s;
    }

    &::before {
      right: 50%;
    }

    &::after {
      left: 50%;
    }

    &:hover::before,
    &:hover::after {
      width: 50%;
    }
  }
}

.admin {
  @media screen and (width <= 640px) {
    width: unset;
    border: 1px solid var(--color-gray-200);
    border-radius: 2px;
  }
}

.spGuest {
  display: flex;
  align-items: center;
}

.placeholderWidth {
  width: 56px;
}

.sp {
  @media screen and (width >= 641px) {
    display: none;
  }
}

.pc {
  @media screen and (width <= 640px) {
    display: none;
  }
}
